export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ18.41ef550c.mp3";